import { render, staticRenderFns } from "./WeekSelector.vue?vue&type=template&id=4e119d10&scoped=true&"
import script from "./WeekSelector.vue?vue&type=script&lang=js&"
export * from "./WeekSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e119d10",
  null
  
)

export default component.exports